import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { DepositJackpotModalComponent } from '@features/jackpot/modals/deposit-jackpot-modal/deposit-jackpot-modal.component';
import { JackpotSkinsModalComponent } from '@features/jackpot/modals/jackpot-skins-modal/jackpot-skins-modal.component';
import { JackpotRoundDetailsModalComponent } from '@features/jackpot/modals/jackpot-round-details-modal/jackpot-round-details-modal.component';

export function provideJackpotModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'DepositJackpotModal', component: DepositJackpotModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'JackpotSkinsModal', component: JackpotSkinsModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'JackpotRoundDetailsModal', component: JackpotRoundDetailsModalComponent }, multi: true },
  ];
}
